import React, { useEffect, useState } from 'react'
import cn from 'classnames'
import { formatRadioChance } from 'components/shared/MediaDock/RadioChanceRow'
import { subscribeRadioNow } from 'state/radioNowFeed'
import styles from 'components/panels/radio-on-air-header.module.scss'

// The Music channel's header line, in place of the host, visibility and
// member rows: whether the station is on air, and the odds the song playing
// now won its draw at (the same figure the dock's Radio tab shows).
export default function RadioOnAirHeader() {
    const [feed, setFeed] = useState(null)

    // Passive: reading the station never counts as listening.
    useEffect(
        () => subscribeRadioNow(payload => setFeed(payload || null), { contenders: false }),
        [],
    )

    const now = feed?.now || null
    const onAir = Boolean(now?.track)
    const chance = onAir ? now.chance : null

    return (
        <div className={styles.onAirHeader} data-testid="radio-on-air-header">
            <span className={cn(styles.onAirBadge, !onAir && feed && styles.offAir)}>
                <span className={styles.onAirDot} aria-hidden="true" />
                {onAir || !feed ? 'On air' : 'Off air'}
            </span>
            {chance != null && (
                <span
                    className={styles.onAirOdds}
                    title={
                        now.blockHeight
                            ? `Drawn by BSV block #${now.blockHeight.toLocaleString()}`
                            : undefined
                    }
                >
                    <span className={styles.onAirOddsValue}>{formatRadioChance(chance)}</span>
                    <span className={styles.onAirOddsLabel}>
                        {now.weightSource === 'discovery'
                            ? 'odds · discovery pick'
                            : 'odds · won the draw'}
                    </span>
                </span>
            )}
        </div>
    )
}
